import cloneDeep from 'clone-deep';
import color from 'color';
import { createMuiTheme } from '@material-ui/core/styles';
import appTheme from './app.theme';

const primaryMain = '#a363ff';

const palette = {
  primary: {
    main: primaryMain,
    light: '#eeeae3',
  },
  secondary: {
    main: '#6200ee',
  },
  text: {
    primary: '#6200ee',
  },
  action: {
    hoverOpacity: 0.1,
  },
  tonalOffset: 0.35,
};

const theme = cloneDeep(appTheme);
theme.palette = palette;
theme.overrides.MuiButton.containedPrimary = {
  '&:hover': {
    backgroundColor: color(palette.primary.main)
      .lighten(palette.action.hoverOpacity)
      .hex(),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: palette.primary.main,
    },
  },
};

export default createMuiTheme(theme);
